import '../css/style.css';

// Amplify
import '../../lib/frontend/amplifyClient';

// Phaser
import Phaser from 'phaser';

// ゲーム設定と定数
import { config, CONSTANTS, gameState } from '@game/game';

// localStorageからBGMの状態を読み込む
const savedBgmEnabled = localStorage.getItem('bgmEnabled');
if (savedBgmEnabled !== null) {
  gameState.bgmEnabled = savedBgmEnabled === 'true';
}

// BootSceneのみ明示的にインポート
import { BootScene } from '@game/scenes/BootScene';

// 動的インポート
// オブジェクトファイルの自動インポート
const objectModules = import.meta.glob('@game/objects/*.js', { eager: true });
// マネージャーファイルの自動インポート
const managerModules = import.meta.glob('@game/managers/*.js', { eager: true });
// シーンファイルの自動インポート（BootScene以外）
const sceneModules = import.meta.glob('@game/scenes/*.(js|ts)', { eager: true });

// グローバルオブジェクトの作成
window.GameClasses = {};

// オブジェクトクラスをグローバルに登録
Object.values(objectModules).forEach(module => {
  Object.keys(module).forEach(exportName => {
    window.GameClasses[exportName] = module[exportName];
  });
});

// マネージャークラスをグローバルに登録
Object.values(managerModules).forEach(module => {
  Object.keys(module).forEach(exportName => {
    window.GameClasses[exportName] = module[exportName];
  });
});

// シーン配列の作成（BootSceneを最初に配置）
const scenes = [BootScene];

// BootSceneをグローバルに登録
window.GameClasses.BootScene = BootScene;

// 他のシーンクラスを動的に登録
Object.values(sceneModules).forEach(module => {
  Object.keys(module).forEach(exportName => {
    // クラス名がSceneで終わるものだけを対象とする
    if (exportName.endsWith('Scene') && exportName !== 'BootScene') {
      // シーン配列に追加
      scenes.push(module[exportName]);
      // グローバルオブジェクトに登録
      window.GameClasses[exportName] = module[exportName];
    }
  });
});

// 画面の再中央寄せ
const handleOrientation = () => {
  window.scrollTo(0, 0);
};

// 画面回転時に再中央寄せ
window.addEventListener('orientationchange', () => {
  setTimeout(handleOrientation, 100);
});

// 初期ロード時に中央寄せ
window.addEventListener('load', handleOrientation);

// ゲームインスタンスの作成
const game = new Phaser.Game({
  ...config,
  scene: scenes
});

// グローバルオブジェクトとして公開
window.game = game;
window.gameState = gameState;
window.CONSTANTS = CONSTANTS;

// 開発モードの場合、コンソールにグローバルオブジェクトを表示
if (import.meta.env.DEV) {
  console.log('Game Classes:', window.GameClasses);
  console.log('Game:', window.game);
  console.log('Game State:', window.gameState);
  console.log('Constants:', window.CONSTANTS);
} else {
  console.log('本番モードで実行中');
}

// デバッグ情報
console.log('Phaser Version:', Phaser.VERSION);
console.log('環境:', import.meta.env.MODE);
console.log('ベースURL:', import.meta.env.BASE_URL);
